import React from "react";
import { THEMES, THEME_OPTIONS, useTheme } from "../ThemeContext";

export const ThemeSelector = () => {
	const { theme, setTheme } = useTheme();

	// Theme previews with their main colors
	const themePreviewColors = {
		[THEMES.LINEAR]: ["#222326", "#2b2c30", "#222326"],
		[THEMES.LINEAR_LIGHT]: ["#f4f5f8", "#e7e9ee", "#222326"],
	};

	// Theme display names
	const themeNames = {
		[THEMES.LINEAR]: "Linear Dark",
		[THEMES.LINEAR_LIGHT]: "Linear Light",
	};

	return (
		<div className="grid grid-cols-2 sm:grid-cols-3 gap-4 py-4">
			{THEME_OPTIONS.map((themeValue) => {
				const themeName = themeNames[themeValue];
				const colors =
					themePreviewColors[themeValue] || themePreviewColors[THEMES.LINEAR];
				const isSelected = theme === themeValue;

				return (
					<button
						type="button"
						key={themeValue}
						onClick={() => setTheme(themeValue)}
						className={`flex flex-col items-center p-3 rounded-lg border transition-all ${
							isSelected
								? "border-[var(--color-selection)] ring-1 ring-[var(--color-selection-ring)]"
								: "border-[var(--color-border)] hover:border-[var(--color-accent)]"
						}`}
						aria-label={`Select ${themeName} theme`}
						aria-pressed={isSelected}
					>
						<div className="w-full h-12 rounded-md overflow-hidden flex mb-2 shadow-sm">
							<div className="w-2/3" style={{ backgroundColor: colors[0] }} />
							<div className="w-1/3" style={{ backgroundColor: colors[1] }} />
							<div className="w-1/12" style={{ backgroundColor: colors[2] }} />
						</div>
						<span className="text-xs font-medium text-[var(--color-text-primary)]">
							{themeName}
						</span>
					</button>
				);
			})}
		</div>
	);
};
